{
  "shellWaitLabel": "Chargement"
}
